import { Feature } from '@wwt/entities/search-response'

import { baseExtractFeaturesAndGroups } from './baseExtractFeaturesAndGroups.ts'
import { GroupAllFeaturesResultElement } from './groupAllFeaturesTypes.ts'
import { transformGroupsInnerToResult } from './transformGroupsInnerToResult.ts'

export const groupAllFeatures = (
	featuresInput: Feature[],
	optionPrioritySort = true
): GroupAllFeaturesResultElement[] => {
	const inner = baseExtractFeaturesAndGroups(featuresInput)

	return transformGroupsInnerToResult(inner, optionPrioritySort)
}
